<article
  *ngIf="
    !(isLoading$ | async) && batchDeparture() as batchDeparture;
    else departureMainBlock
  "
  class="departure-card"
  [ngClass]="{ 'departure-card__full': isFullScreen$ | async }"
>
  <header class="departure-card__header">
    <span class="departure-card__header-title">
      {{
        'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.DEPARTURE_INFO' | translate
      }}
    </span>

    <div class="departure-card__header-manage-block">
      <a
        class="filter-button azure pointer"
        type="button"
        (click)="toggleFullScreen()"
      >
        <span
          class="filter-button-icon fullscreen-btn"
          [inlineSVG]="
            '../assets/img/icons/fullscreen-' +
            ((isFullScreen$ | async) ? 'off' : 'on') +
            '.svg'
          "
        ></span>

        <span>
          {{
            ((isFullScreen$ | async) ? 'FULLSCREEN_OFF' : 'FULLSCREEN_TOOLTIP')
              | translate
          }}
        </span>
      </a>

      <button
        class="filter-button red"
        *ngIf="batch?.status === BatchStatusEnum.UNCOMMITED"
        type="button"
        (click)="confirmDeleteDeparture()"
      >
        <fa-icon class="filter-button-icon red" [icon]="faTrashAlt"> </fa-icon>

        <span class="red">{{ 'DELETE' | translate }}</span>
      </button>
    </div>
  </header>

  <section
    class="departure-card__header-track-block"
    *ngIf="
      batchDeparture.tracking_code && batch?.status === BatchStatusEnum.COMMITED
    "
  >
    <ng-container [ngSwitch]="batchDeparture.tracking_code.main_status">
      <span
        class="status status__no-data"
        *ngSwitchCase="BatchMailingStatus.NO_DATA"
      >
        {{ 'NO_DATA' | translate }}
      </span>

      <span
        class="status status__handed"
        *ngSwitchCase="BatchMailingStatus.AWARDED"
      >
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.HANDED' | translate }}
      </span>

      <span
        class="status status__rejected"
        *ngSwitchCase="BatchMailingStatus.REJECTED"
      >
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.REFUND' | translate }}
      </span>

      <span
        class="status status__on-the-road"
        *ngSwitchCase="BatchMailingStatus.ON_THE_ROAD"
      >
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.ON_THE_WAY' | translate
        }}
      </span>

      <span
        class="status status__redirected"
        *ngSwitchCase="BatchMailingStatus.REDIRECTED"
      >
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.REDIRECTED' | translate
        }}
      </span>

      <span
        class="status status__pickup"
        *ngSwitchCase="BatchMailingStatus.PICKUP"
      >
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.TO_BE_ISSUED' | translate
        }}
      </span>
    </ng-container>

    <div
      *ngIf="batchDeparture.tracking_code.updated_at; else createdAtBlock"
      class="departure-card__header-track-block-update"
    >
      <span>
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.LAST_UPDATE' | translate }}
        -
      </span>

      <span>
        {{
          dayjs(
            batchDeparture.tracking_code.updated_at,
            'YYYY-MM-DD HH:mm'
          ).format('DD.MM.YYYY HH:mm')
        }}
      </span>
    </div>

    <ng-template #createdAtBlock>
      <div class="departure-card__header-track-block-update">
        <span>{{ 'BATCH_MAILING.BATCHES_TAB.CREATED_AT' | translate }} - </span>

        <span>
          {{
            dayjs(
              batchDeparture.tracking_code.created_at,
              'YYYY-MM-DD HH:mm'
            ).format('DD.MM.YYYY HH:mm') || '-'
          }}
        </span>
      </div>
    </ng-template>
  </section>

  <main class="departure-card__content">
    <section class="departure-card__content-item">
      <span class="title">
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.S10CODE' | translate }}
      </span>

      <span>{{ batchDeparture.s10code || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.WEIGHT' | translate }}
      </span>

      <span>{{ batchDeparture.weight || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.COST' | translate }}
      </span>

      <span>{{ batchDeparture.cost || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.ADDITION_SERVICE_PRICE'
            | translate
        }}
      </span>

      <span>{{ batchDeparture?.additional_services_price || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.DECLARED_VALUE' | translate
        }}
      </span>

      <span>{{ batchDeparture.addons.declared_value || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">{{ 'DELIVERY.CASH_ON_DELIVERY' | translate }}</span>

      <span>{{ batchDeparture.addons.cash_on_delivery || '-' }}</span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.RECIPIENT_NAME' | translate
        }}
      </span>
      <span>{{ recipientName() }} </span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.RECIPIENT_ADDRESS'
            | translate
        }}
      </span>

      <span>
        {{
          batchDeparture?.recipient_contact_widget_data.address.full_address ||
            '-'
        }}
      </span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.SPECIAL_MARKS' | translate
        }}
      </span>

      <app-special-marks-full
        [addons]="batchDeparture.addons"
      ></app-special-marks-full>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.NOTIFICATIONS' | translate
        }}
      </span>

      <span>
        {{ NOTIFICATIONS_MAP.get(batchDeparture.notification) | translate }}
      </span>
    </section>

    <section
      *ngIf="batchDeparture.notification === '5'"
      class="departure-card__content-item"
    >
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.WHERE_TO_SEND_NOTIFICATION'
            | translate
        }}
      </span>

      <span *ngIf="batchDeparture.addons.phone">
        {{ checkPhonePrefix(batchDeparture.addons.phone) }}
      </span>

      <span *ngIf="batchDeparture.addons.email">
        {{ batchDeparture.addons.email }}
      </span>
    </section>

    <section class="departure-card__content-item">
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.NOTIFICATION_S10CODE'
            | translate
        }}
      </span>

      <span>{{ batchDeparture?.notification_s10code || '-' }}</span>
    </section>

    <section
      *ngIf="batch.postal_delivery_type?.includes('ecommerce') && isELS"
      class="departure-card__content-item"
    >
      <span class="title">
        {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.SHELF_LIFE' | translate }}
      </span>

      <span>{{ batchDeparture.addons.shelf_life }}</span>
    </section>

    <section
      class="departure-card__content-item"
      *ngIf="
        batchDeparture.date_cod_payment &&
        batchDeparture.payment_price &&
        batchDeparture.by_code_payment
      "
    >
      <span class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.CASH_ON_DELIVERY_TO_RECEIVED'
            | translate
        }}
      </span>

      <div>
        <span>
          {{
            dayjs(batchDeparture.date_cod_payment, 'YYYY-MM-DD HH:mm').format(
              'DD.MM.YYYY HH:mm'
            )
          }},
        </span>

        <span>
          {{ batchDeparture.payment_price }} {{ 'BYN' | translate }},
        </span>

        <br />

        <span>{{ batchDeparture.by_code_payment }}</span>
      </div>
    </section>
  </main>

  <article class="departure-card__tabs-block">
    <section
      class="tabs tabs--thin tabs--in-box tabs-with-state-tab"
      *ngIf="batch.is_partial_receipt"
    >
      <div class="nav" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link"
          [ngClass]="{ active: activeTab === 1 }"
          data-toggle="tab"
          routerLinkActive="active"
          role="tab"
          (click)="setActiveTab(1)"
        >
          {{
            'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.ATTACHMENT' | translate
          }}
        </a>

        <a
          class="nav-item nav-link"
          [ngClass]="{ active: activeTab === 2 }"
          data-toggle="tab"
          routerLinkActive="active"
          role="tab"
          (click)="setActiveTab(2)"
        >
          {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.TRACKING' | translate }}
        </a>
      </div>

      <div class="tabs__line" aria-hidden="true"></div>
    </section>

    <ng-container *ngIf="batch.is_partial_receipt">
      <ng-container *ngIf="activeTab === 1">
        <section
          class="departure-card__tabs-block-attachments"
          *ngFor="
            let status of Object.keys(convertedAttachments);
            let i = index
          "
        >
          <div
            class="departure-card__tabs-block-attachments-status"
            [ngStyle]="{
              'justify-content':
                status !== 'pending' ? 'space-between' : 'flex-end',
            }"
          >
            <p *ngIf="status === 'issued'" class="main-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.HANDED_RECIPIENT'
                  | translate
              }}
            </p>

            <p *ngIf="status === 'canceled'" class="main-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.CANCELLED'
                  | translate
              }}
            </p>

            <div *ngIf="i === 0 && batchDeparture.back_track_code">
              <span class="title">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.BARCODE'
                    | translate
                }}:
              </span>

              <span
                class="pointer"
                (click)="copyToClipboard(batchDeparture.back_track_code)"
              >
                <fa-icon [icon]="faCopy"></fa-icon>

                <strong> {{ batchDeparture.back_track_code }}</strong>
              </span>
            </div>
          </div>

          <ng-container *ngFor="let attachment of convertedAttachments[status]">
            <app-attachment-card
              [isEditable]="false"
              [departureAttachment]="attachment"
            >
            </app-attachment-card>
          </ng-container>
        </section>
      </ng-container>

      <ng-container *ngIf="activeTab === 2">
        <ng-container *ngTemplateOutlet="trackingTemplate"></ng-container>
      </ng-container>
    </ng-container>
  </article>

  <ng-container *ngIf="!batch.is_partial_receipt">
    <ng-container *ngTemplateOutlet="trackingTemplate"></ng-container>
  </ng-container>

  <ng-template #trackingTemplate>
    <section
      class="departure-card__track"
      *ngIf="
        batch.status !== BatchStatusEnum.UNCOMMITED &&
        batchDeparture.s10code &&
        batchDeparture.tracking_code
      "
    >
      <section class="departure-card__track-header">
        <span class="main-title">
          {{ 'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.TRACKING' | translate }}
        </span>

        <button
          type="button"
          [disabled]="isTrackLoading$ | async"
          (click)="reloadTrack(batchDeparture)"
        >
          <fa-icon
            [icon]="faSyncAlt"
            class="azure"
            tooltip="{{
              (isTrackLoading$ | async)
                ? ('PLEASE_WAIT' | translate)
                : ('REFRESH' | translate)
            }}"
          >
          </fa-icon>
        </button>
      </section>

      <ng-container *ngIf="!(isTrackLoading$ | async); else departureMainBlock">
        <div
          class="departure-card__track-container"
          *ngIf="batchDeparture.tracking_code.steps.length; else noSteps"
        >
          <div class="departure-card__track-container-item">
            <span class="departure-card__track-container-title">
              {{ batchDeparture.tracking_code.steps[0].event }}
            </span>

            <div>
              <span class="gray-text">
                {{
                  dayjs(
                    batchDeparture.tracking_code.steps[0].created_at,
                    'YYYY-MM-DD HH:mm'
                  ).format('DD.MM.YYYY HH:mm') || '-'
                }}
                &#183;
              </span>

              <a
                class="pointer"
                [queryParams]="{ search_by: 'postcode' }"
                [routerLink]="
                  opsUrl + batchDeparture.tracking_code.steps[0].place_index
                    | localize
                "
              >
                <span>
                  {{ batchDeparture.tracking_code.steps[0].place_index }}
                </span>

                <span>{{ batchDeparture.tracking_code.steps[0].place }}</span>
              </a>
            </div>
          </div>

          <ng-container *ngIf="showAllSteps">
            <ng-container
              *ngFor="let step of batchDeparture.tracking_code.steps | slice: 1"
            >
              <div class="departure-card__track-container-item">
                <span class="departure-card__track-container-title">
                  {{ step.event }}
                </span>

                <div>
                  <span class="gray-text">
                    {{
                      dayjs(step.created_at, 'YYYY-MM-DD HH:mm').format(
                        'DD.MM.YYYY HH:mm'
                      ) || '-'
                    }}
                    &#183;
                  </span>

                  <a
                    class="pointer"
                    [queryParams]="{ search_by: 'postcode' }"
                    [routerLink]="opsUrl + step.place_index | localize"
                  >
                    <span>{{ step.place_index }} </span>

                    <span>{{ step.place }}</span>
                  </a>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <button
            type="button"
            class="departure-card__track-show-more-btn azure"
            (click)="onShowMoreClick()"
          >
            <span>{{ 'MORE' | translate }}</span>

            <img
              [ngClass]="{ btn_active: showAllSteps }"
              src="assets/img/icons/chevron-down.svg"
              alt="chevron-down"
            />
          </button>
        </div>
      </ng-container>

      <ng-template #noSteps>
        <div class="departure-card__track-empty-steps">
          <img
            src="assets/img/icons/warning.svg"
            width="20px"
            height="20px"
            alt="warning"
          />

          <span>{{ 'NO_TRACK_INFO' | translate }}</span>
        </div>
      </ng-template>
    </section>
  </ng-template>

  <footer class="departure-card__header">
    <button
      type="button"
      class="button button--outlined"
      (click)="navigateToViewBatch()"
    >
      {{ 'BACK' | translate }}
    </button>

    <button
      *ngIf="batch.status === BatchStatusEnum.UNCOMMITED"
      class="button button--filled"
      (click)="navigateToEditDeparturePage()"
    >
      <span>{{ 'EDIT' | translate }}</span>
    </button>
  </footer>
</article>

<ng-template #departureMainBlock>
  <div class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
</ng-template>
